module.exports = __webpack_public_path__ + "static/img/culture_1.13603d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture_1.png
// module id = ZIgF
// module chunks = 1